var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('van-steps',{attrs:{"active":_vm.active}},[_c('van-step',[_vm._v("阅读协议")]),_c('van-step',[_vm._v("确认信息")]),_c('van-step',[_vm._v("提交验证")]),_c('van-step',[_vm._v("验证完成")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }